/**
 * Moving a chore on the shared display (#583, owner decision d-20261001-42) — which targets the
 * board OFFERS the person signed in at it. No React and no network.
 *
 * The rule, in the owner's words: "anyone can drag a chore from someone to themself. parents can
 * drag chores from anyone to anyone else including putting chore from a user into unassigned
 * bucket". So:
 *
 * | who is signed in | may move a chore to |
 * | --- | --- |
 * | anyone | themselves, from anyone or from unassigned |
 * | a parent | also any other member, and back to unassigned |
 *
 * The SERVER decides every move (`server/services/chore.service.js` `reassignChore`, on the actor's
 * locked user row). `canMoveAnyChore` is the server's display hint from the PIN check; only a real
 * `true` widens the list, so a missing or odd flag can only ever offer less.
 */

/** The drop key of the "Anyone can do these" row. */
export const SHARED = 'shared';
export const SHARED_TITLE = 'Anyone can do these';

/**
 * @param {object} input
 * @param {{userId:number, canMoveAnyChore?:boolean}|null} input.actor
 * @param {number|null} input.ownerId  who holds the chore now; null = unassigned
 * @param {Array<{id:number, name:string}>} input.members  the board's columns, in board order
 * @returns {Array<{key:string, userId:number|null, label:string}>}
 */
export function moveTargets({ actor, ownerId, members }) {
  if (!actor) return [];
  const list = Array.isArray(members) ? members : [];
  const self = list.find((m) => String(m.id) === String(actor.userId));
  if (!self) return [];
  const held = (id) => ownerId != null && String(id) === String(ownerId);
  const label = (m) => (m === self ? `Move to me (${m.name})` : `Move to ${m.name}`);
  const toMember = (m) => ({ key: String(m.id), userId: m.id, label: label(m) });

  if (actor.canMoveAnyChore !== true) return held(self.id) ? [] : [toMember(self)];
  const targets = list.filter((m) => !held(m.id)).map(toMember);
  if (ownerId != null) targets.push({ key: SHARED, userId: null, label: `Move to ${SHARED_TITLE}` });
  return targets;
}
